<template>
  <div class="sfgrd-main-wrap">
    <tk-page
      :page-config="objPageConfig"
      :obj-table="objTable"
      :obj-form="objSelectForm"
      :obj-buttons="objButtons"
      @onSearch="queryData"
      @onReset="resetFields"
    ></tk-page>

    <dialog-approval ref="dialogApproval" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  vehicleMap,
  APPROVAL_STATE_OPTIONS,
  APPROVAL_LEVEL_OPTIONS,
} from "@/common/js/constConfig";
import DialogApproval from "./components/DialogApproval.vue";

export default {
  name: "fixedPrice",
  components: {
    DialogApproval,
  },
  data() {
    return {
      objPageConfig: {
        pageTitle: "一口价找车审核", // 页面标题-用户神策埋点
        columnCacheKey: "SAAS-OrderApprovalFixedPrice", // 需缓存的key，无则不缓存
        fixHeight: 162, // 获取用户屏幕高度
        // isScrollFixed: false, // 是否table滚动时fixed
        // fillLayout: true, // 是否自动填充高度	Boolean	默认true
        // isShowColumnSetting: true, //	是否显示定制列 Boolean 默认显示 true
        // defaultTableSize: "small", // 表格默认尺寸	String	small \ mini	‘small’
        // isEmptyFullScreen: true, // 无数据时高度占满高度 Boolean 默认 true
        // isShowTableConfig: true, // 是否显示表格个性化操作栏 Boolean 默认显示 true
        isDefaultSearch: true, // 是否默认查询
      },
      objTable: {
        loading: false,
        height: "500px", // 设置无数据占满时需设置默认高度
        "row-key": "id",
        objPage: {
          pn: 1,
          size: 10,
          pageSizes: [10, 20, 50, 100], // 分页跨度
          pnFunc: (pn) => {
            this.objTable.objPage.pn = pn;
            this.searchList();
          },
          pzFunc: (size) => {
            this.objTable.objPage.size = size;
            this.searchList();
          },
        },
        tableData: [],
        tableColumn: [
          {
            type: "index",
            field: "index",
            title: "序号",
            width: 46,
            fixed: true,
          },
          {
            field: "approvalNo",
            title: "审批流水号",
            minWidth: 90,
          },
          {
            field: "srcAddr",
            title: "线路",
            minWidth: 300,
            formatter: (row) => {
              return (
                <div>
                  <span class="point src"></span>
                  {row.srcAddr}
                  <br />
                  <span class="point dest"></span>
                  {row.destAddr}
                </div>
              );
            },
          },
          {
            field: "approvalStateStr",
            title: "审批状态",
            minWidth: 80,
          },
          {
            field: "planDepartTmStr",
            title: "计划发车时间",
            minWidth: 140,
          },
          {
            field: "vehicleType",
            title: "车型车长",
            minWidth: 110,
            formatter: (row) => {
              let vehicleTypeStr = "";
              if (row.vehicleType) {
                vehicleMap.forEach((item) => {
                  row.vehicleType === item.plVehicleCode &&
                    (vehicleTypeStr = item.plVehicleType);
                });
              }
              return `${vehicleTypeStr} / ${
                row.vehicleLength ? row.vehicleLength + "m" : "--"
              }`;
            },
          },
          {
            field: "price",
            title: "期望运费",
            minWidth: 80,
          },
          {
            field: "contractPrice",
            title: "合同价格",
            minWidth: 80,
          },
          {
            field: "floatRatioStr",
            title: "浮动比例",
            minWidth: 80,
          },
          {
            field: "approvalName",
            title: "审核人",
            minWidth: 80,
          },
          {
            field: "approvalTm",
            title: "审核时间",
            minWidth: 140,
            formatter: (row) => {
              return this.$commonUtil.dateFormatByMoment(row.approvalTm);
            },
          },
          {
            field: "reason",
            title: "审核说明",
            minWidth: 140,
            overflowtooltip: true,
          },
          {
            type: "columnOperation",
            align: "center",
            title: "操作",
            fixed: "right",
            width: 160, // 默认120 刚好放下2个2个文字按钮
            // showNum: 3, // 默认2个
            btns: () => {
              return [
                {
                  name: "省区中控审核",
                  click: (scope) => {
                    this.handleApproval(scope.row);
                  },
                  show: (scope) => {
                    return (
                      this.showBtns[
                        "orderApprovalFixedPrice_ApprovalProvince"
                      ] &&
                      scope.row.approvalState === 0 &&
                      scope.row.approvalLevel === 1
                    );
                  },
                },
                {
                  name: "运营部负责人审批",
                  click: (scope) => {
                    this.handleApproval(scope.row);
                  },
                  show: (scope) => {
                    return (
                      this.showBtns[
                        "orderApprovalFixedPrice_ApprovalDepartment"
                      ] &&
                      scope.row.approvalState === 0 &&
                      scope.row.approvalLevel === 2
                    );
                  },
                },
                {
                  name: "总部中控审核",
                  click: (scope) => {
                    this.handleApproval(scope.row);
                  },
                  show: (scope) => {
                    return (
                      this.showBtns[
                        "orderApprovalFixedPrice_ApprovalHeadquarters"
                      ] &&
                      scope.row.approvalState === 0 &&
                      scope.row.approvalLevel === 3
                    );
                  },
                },
                {
                  name: "取消",
                  click: (scope) => {
                    this.handleCancel(scope.row);
                  },
                  show: (scope) => {
                    return (
                      this.showBtns["orderApprovalFixedPrice_Cancel"] &&
                      scope.row.approvalState === 0
                    );
                  },
                },
              ];
            },
          },
        ],
      },
      objSelectForm: {
        // labelWidth: '100px', // 设置labelWidth则使用设置的宽度。不设置的话，一行显示
        // isValidForm: true,// 是否为有校验的表单，默认为false true间距高度为15
        size: "mini", // 表单size，需要指定，否则不会默认为mini，样式会有问题
        showSearchBtn: () => {
          return this.showBtns["orderApprovalFixedPrice_Query"];
        },
        model: {
          orderType: 2, // 订单类型 1.指派 2一口价
        },
        arrFormItem: [
          {
            label: "审批单号",
            prop: "approvalNo",
            element: "el-input",
          },
          {
            label: "发货地址",
            prop: "srcAddr",
            element: "el-input",
          },
          {
            label: "收货地址",
            prop: "destAddr",
            element: "el-input",
          },
          {
            label: "计划发车时间",
            prop: "planDepartTm",
            element: "el-date-picker",
            type: "daterange",
            "value-format": "yyyy-MM-dd",
            format: "yyyy-MM-dd",
            isRange: true,
            defaultVal: [],
          },
          {
            label: "审批状态",
            prop: "approvalState",
            element: "el-select",
            options: APPROVAL_STATE_OPTIONS,
          },
          {
            label: "审批等级",
            prop: "approvalLevel",
            element: "el-select",
            options: APPROVAL_LEVEL_OPTIONS,
          },
        ],
      },
      objButtons: {
        arrBtnItem: [],
      },
    };
  },
  computed: {
    showBtns() {
      let obj = {};
      let menuMap = this.$store.state.login.menuMap;
      if (menuMap && menuMap["orderApprovalFixedPrice"]) {
        let submenuList = menuMap["orderApprovalFixedPrice"].split("-");
        submenuList.forEach((item) => {
          obj[item] = true;
        });
      }
      return obj;
    },
  },
  created() {
    this.objSelectForm.model = this.$commonUtil.getModelObj(this.objSelectForm);
  },
  methods: {
    ...mapActions(["orderApprovalQueryPage", "orderApprovalCancel"]),
    queryData() {
      this.objTable.objPage.pn = 1;
      this.searchList();
    },
    searchList() {
      const params = Object.assign(
        {},
        {
          pageNum: this.objTable.objPage.pn,
          pageSize: this.objTable.objPage.size,
        },
        this.formatParams()
      );
      this.objTable.loading = true;
      this.orderApprovalQueryPage(params)
        .then((res) => {
          this.objTable.tableData = res.rows;
          this.objTable.objPage.total = res.totalCount;
        })
        .catch(() => {
          this.objTable.tableData = [];
          this.objTable.objPage.total = 0;
        })
        .finally(() => {
          this.objTable.loading = false;
        });
    },
    resetFields() {},
    formatParams() {
      let params = Object.assign({}, this.objSelectForm.model);
      if (params.planDepartTm && params.planDepartTm.length > 0) {
        params.planDepartStartTm = params.planDepartTm[0] + " 00:00:00";
        params.planDepartEndTm = params.planDepartTm[1] + " 23:59:59";
      } else {
        params.planDepartStartTm = "";
        params.planDepartEndTm = "";
      }
      delete params.planDepartTm;
      return params;
    },
    handleApproval(row) {
      this.$refs.dialogApproval.openDialog({
        row: row,
      });
    },
    handleCancel(row) {
      this.$confirm("此操作将取消该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.orderApprovalCancel({
            id: row.id,
          }).then(() => {
            this.$message.success("取消成功!");
            this.searchList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less"></style>
